import styled from 'styled-components';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';

export const SubscriberProductLinesStyled = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  gap: 3rem;
  margin: 0;
  padding: 0;
  list-style: none;

  ${breakpointsMQ4.sm.down} {
    grid-template-columns: 1fr;
  }
`;
